(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE   = 'cubic-bezier(0.16, 1, 0.3, 1)';
  var DUR    = 1.2; /* seconds */

  var INITIAL = {
    'fade-up':    { opacity: '0', transform: 'translateY(24px)' },
    'fade-down':  { opacity: '0', transform: 'translateY(-16px)' },
    'fade-left':  { opacity: '0', transform: 'translateX(-24px)' },
    'fade-right': { opacity: '0', transform: 'translateX(24px)' },
    'fade':       { opacity: '0', transform: '' },
    'scale-in':   { opacity: '0', transform: 'scale(0.96)' },
    'blueprint':  { opacity: '0', transform: 'scale(0.98) translateY(16px)' },
  };

  var FINAL = {
    'fade-up':    { opacity: '1', transform: 'translateY(0px)' },
    'fade-down':  { opacity: '1', transform: 'translateY(0px)' },
    'fade-left':  { opacity: '1', transform: 'translateX(0px)' },
    'fade-right': { opacity: '1', transform: 'translateX(0px)' },
    'fade':       { opacity: '1', transform: '' },
    'scale-in':   { opacity: '1', transform: 'scale(1)' },
    'blueprint':  { opacity: '1', transform: 'scale(1) translateY(0px)' },
  };

  function applyInitial(el, preset) {
    var s = INITIAL[preset] || INITIAL['fade-up'];
    el.style.opacity = '0';
    if (s.transform) el.style.transform = s.transform;
    el.style.willChange = 'opacity, transform';
  }

  function play(el, preset, delay) {
    var to = FINAL[preset] || FINAL['fade-up'];

    if (REDUCE) {
      el.style.opacity = '1';
      el.style.transform = to.transform || '';
      el.style.willChange = 'auto';
      return;
    }

    var ms = Math.round(delay * 1000);

    function doPlay() {
      // Double rAF: ensures opacity:0 is painted before transition starts,
      // then we set opacity:1 in the next frame so the browser sees a change to animate.
      requestAnimationFrame(function () {
        el.style.transition =
          'opacity ' + DUR + 's ' + EASE + ', transform ' + DUR + 's ' + EASE;
        requestAnimationFrame(function () {
          el.style.opacity = '1';
          el.style.transform = to.transform || '';
          setTimeout(function () {
            el.style.willChange = 'auto';
            el.style.transition = '';
          }, Math.ceil(DUR * 1000) + 50);
        });
      });
    }

    if (ms > 0) {
      setTimeout(doPlay, ms);
    } else {
      doPlay();
    }
  }

  function observe(el, cb) {
    if (!window.IntersectionObserver) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        io.unobserve(el);
        cb();
      }
    }, { threshold: 0.1 });
    io.observe(el);
  }

  function initAnim() {
    var els = document.querySelectorAll('[data-anim]');
    els.forEach(function (el) {
      var preset  = el.dataset.anim;
      var delay   = parseFloat(el.dataset.animDelay || '0');
      var trigger = el.dataset.animTrigger || 'view';
      applyInitial(el, preset);
      if (trigger === 'load') {
        play(el, preset, delay);
      } else {
        observe(el, function () { play(el, preset, delay); });
      }
    });
  }

  function initStagger() {
    var groups = document.querySelectorAll('[data-anim-stagger]');
    groups.forEach(function (group) {
      var preset   = group.dataset.animStagger;
      var delay    = parseFloat(group.dataset.animDelay || '0');
      var step     = parseFloat(group.dataset.animStep || '0.08');
      var trigger  = group.dataset.animTrigger || 'view';
      var children = Array.from(group.children);
      children.forEach(function (child) { applyInitial(child, preset); });
      function fire() {
        children.forEach(function (child, i) {
          play(child, preset, delay + i * step);
        });
      }
      if (trigger === 'load') fire();
      else observe(group, fire);
    });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-count-up]');
    els.forEach(function (el) {
      var target  = parseFloat(el.dataset.countUp);
      if (isNaN(target)) return;
      var dec     = parseInt(el.dataset.countDecimals || '0', 10);
      var dur     = parseFloat(el.dataset.countDuration || '1.4') * 1000;
      var delay   = parseFloat(el.dataset.countDelay   || '0') * 1000;
      var prefix  = el.dataset.countPrefix || '';
      var suffix  = el.dataset.countSuffix || '';
      var trigger = el.dataset.countTrigger || 'view';
      function fmt(n) {
        return prefix + n.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suffix;
      }
      el.textContent = fmt(0);
      function run() {
        if (REDUCE) { el.textContent = fmt(target); return; }
        var started = null;
        function tick(now) {
          if (!started) started = now;
          var elapsed = now - started;
          if (elapsed < delay) { requestAnimationFrame(tick); return; }
          var t = Math.min((elapsed - delay) / dur, 1);
          var eased = 1 - Math.pow(1 - t, 4);
          el.textContent = fmt(target * eased);
          if (t < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }
      if (trigger === 'load') run();
      else observe(el, run);
    });
  }

  function initTilt() {
    if (REDUCE) return;
    var cards = document.querySelectorAll('[data-tilt]');
    cards.forEach(function (card) {
      var strength = parseFloat(card.dataset.tiltStrength || '8');
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transition = 'transform 0.12s ease';
        card.style.transform =
          'perspective(900px) rotateY(' + (x * strength * 2).toFixed(1) + 'deg)' +
          ' rotateX(' + (-y * strength).toFixed(1) + 'deg) scale(1.02)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transition = 'transform 0.5s ease';
        card.style.transform = '';
      });
    });
  }

  function initStickyFilter() {
    var filterBar = document.querySelector('.products-filter-bar');
    if (!filterBar) return;

    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'display:block;height:0;';
    filterBar.parentNode.insertBefore(sentinel, filterBar);

    var isFixed = false;

    function tick() {
      var sTop      = sentinel.getBoundingClientRect().top;
      var shouldFix = sTop <= 0;

      if (shouldFix && !isFixed) {
        isFixed = true;
        sentinel.style.height = filterBar.offsetHeight + 'px';
        filterBar.style.cssText =
          'position:fixed;top:0;left:0;right:0;width:100%;' +
          'z-index:100;background:#fff;border-bottom:1px solid #e2e8f0;' +
          'box-shadow:0 2px 8px rgba(0,0,0,.06);';
      } else if (!shouldFix && isFixed) {
        isFixed = false;
        sentinel.style.height = '0';
        filterBar.style.cssText = '';
      }
    }

    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', function () { isFixed = false; tick(); });
    tick();
  }

  function init() {
    initAnim();
    initStagger();
    initCountUp();
    initTilt();
    initStickyFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
